import { SubmitPaymentsDTO } from '../@types/SubmitPaymentsDTO'
import { apiClient } from '@src/services/http-common'
import { useMutation } from '@tanstack/react-query'

const submitMovePayment = async (paymentData: SubmitPaymentsDTO) => {
  const { loanId, ...data } = paymentData
  const url = `/Loans/${loanId}/Payments/Move`
  const response = await apiClient.post<SubmitPaymentsDTO>(url, data)
  return response.data
}

export const usePostPaymentMove = () => {
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: submitMovePayment,
  })

  return [mutateAsync, isPending, reset] as const
}
